<!-- <mat-progress-bar *ngIf="spinner" mode="indeterminate"></mat-progress-bar> -->
<div fxLayout="column">
  <form novalidate (submit)="reset()" #f="ngForm" fxLayout="row" fxLayoutAlign="center"  fxFlexOffset="105px">
    <mat-card class="reset-password-container" fxLayout="column" fxFlex.gt-sm="400px" fxFlex.lt-sm="300px">
      <mat-card-header style="align-items: center;justify-content: center;padding-right: inherit;">
        <img style="width:100px; height: 100px;" src="../../../assets/img/Clamor.jpg" alt="">
        <!-- <img fxFlex="50px" src="../../../assets/icons/logohd.svg" alt=""> CUSTOMIZATION-SOLE24ORE -->
    </mat-card-header>
        <div fxLayout="column">
          <!-- <mat-card-title fxFlexOffset="3px">App24</mat-card-title> -->
          <!-- <mat-card-title fxFlexOffset="3px">Il Sole 24 ORE</mat-card-title> CUSTOMIZATION-SOLE24ORE -->
          <mat-card-subtitle style="text-align: center;">
            (Versione {{version}})</mat-card-subtitle>
        </div>
      <mat-card-content fxLayout="column" class="reset-password-card-content">
        <span fxFlexOffset="16px"
          style="font-size: 16px; font-weight: 500; margin-bottom: 10px;">{{'Multilang.resetEmailText' | translate}}:</span>
        <!-- <mat-form-field fxFlexOffset="16px">
          <input matInput required placeholder="{{'Multilang.email' | translate}}" [(ngModel)]="email" name="email" />
        </mat-form-field> -->
        <div class="textbox mt-2 mb-4" id="textbox-mail">
          <i class="fa fa-envelope" aria-hidden="true"></i>
          <input spellcheck="false" type="text" required placeholder="Email" [(ngModel)]="email" name="email">
        </div>
        <!-- <span fxFlexOffset="16px"
          style="font-style: italic; font-family: serif">{{'Multilang.resetEmailText2' | translate}}</span> -->
      </mat-card-content>
      <mat-card-actions>

        <div class=".container-fluid">
          <div class="row justify-content-end">
            <div class="col-4">
              <a class="back-button" routerLink="/login">
                <i class="fa fa-angle-left pr-1" aria-hidden="true"></i> {{'Multilang.backButton' | translate }}</a>
            </div>
            <div class="col-3 px-0">
              <!-- il bottone -->
              <div class="spinner-container pl-2">
                <!-- Spinner -->
                <mat-spinner *ngIf="spinner" [diameter]="20"></mat-spinner>
              </div>
              <button type="submit" [disabled]="f.invalid" [ngClass]="{
                'login-button': true,
                'login-button-active': !f.invalid,
                'login-button-disabled': f.invalid
              }">Invia</button>
            </div>
          </div>
        </div>

      </mat-card-actions>
    </mat-card>
  </form>
</div>
<!-- Loading -->
<div class="loading-2" *ngIf="spinner">
</div>
